import React from "react"
import * as styles from "./enrollModal.module.scss"
import classnames from "@src/utils/classnames"
import StyleModal from "../modal/styleModal"
import Card from "../card"

import qrImg from "@images/qrcode.png"

const EnrollModal = React.memo(({ ...restProps }) => {
  return (
    <StyleModal {...restProps} className={styles.modal}>
      <div className={styles.container}>
        <Card className={styles.card}>
          <h3 className={styles.title}>微信扫码预约直播</h3>
          <div className={styles.body}>
            <img src={qrImg} alt="QR" />
          </div>
        </Card>
      </div>
    </StyleModal>
  )
})

EnrollModal.displayName = "EnrollModal"
export default EnrollModal
